import React, { useContext, useEffect, useState, useCallback } from "react";
import { DashboardContext } from "context/DashboardContext";
import { ModalContext } from "context/ModalContext";
import { api_srv } from "services";
import { show_toast } from "utils/helpers";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";


function FormDebug() {
  const { errors, touched, isSubmitting } = useFormikContext();
  const { productBenefit } = useContext(DashboardContext);

  useEffect(() => {
    console.log("Form errors:", errors);
    console.log("Touched fields:", touched);
    console.log("isSubmitting:", isSubmitting, "productBenefit.loading:", productBenefit?.loading);
  }, [errors, touched, isSubmitting, productBenefit?.loading]);

  return null;
}

export default function AddProductBenefit({onHide, fetchProductBenefits }) {
  const [benefits, setBenefits] = useState([{ id: "0999", name: "benefits one" }]);
  const [rates, setRates] = useState([]);
  const [slabValues, setSlabValues] = useState({ minimum: "", maximum: "", value: "" });
  const { productBenefit, setProductBenefit } = useContext(DashboardContext);
  const { modalClose } = useContext(ModalContext);

  useEffect(() => {
    console.log("BENEFITS===", productBenefit);
  }, [productBenefit]);

  const validationSchema = Yup.object().shape({
    benefitCategory: Yup.string().required("Benefit Category is required"),
    benefitName: Yup.string().required("Benefit Name is required"),
    benefitReference: Yup.string().required("Benefit Reference is required"),
    benefitDescription: Yup.string().required("Benefit Description is required"),

    benefitEmbededProductRef: Yup.string().when("benefitrateBaseOn", {
      is: "PRODUCT",
      then: Yup.string().required("Embedded Product Reference is required"),
      otherwise: Yup.string().notRequired(),
    }),

    benefitCoverType: Yup.string().required("Cover Type is required"),
    isPremiumBenefit: Yup.boolean().required("Premium Benefit status is required"),
    benefitrateBaseOn: Yup.string().required("Rate Base is required"),
    isConsumedonClaim: Yup.boolean().required("Consumed on Claim status is required"),
    claimReinstatement: Yup.string().required("Claim Reinstatement is required"),
  });

  // const fetchBenefits = useCallback(async () => {
  //   const controller = new AbortController();
  //   try {
  //     const { benefits } = await api_srv.list_benefits({ signal: controller.signal });
  //     setBenefits(benefits);
  //   } catch (err) {
  //     if (err.name !== "AbortError") {
  //       console.error("Error fetching benefits:", err.message, err.stack);
  //       show_toast("Failed to fetch benefits", "error");
  //     }
  //   }
  //   return () => controller.abort();
  // }, []);

  const handleSlabChange = (e) => {
    const { name, value } = e.target;
    console.log(`Slab ${name} changed to:`, value);
    setSlabValues((prev) => ({ ...prev, [name]: value }));
  };

  const addRate = (rateType, values) => {
    if (rateType === "slab") {
      if (slabValues.minimum && slabValues.maximum && slabValues.value) {
        setRates((prev) => [
          ...prev,
          { type: rateType, minimum: slabValues.minimum, maximum: slabValues.maximum, value: slabValues.value },
        ]);
        setSlabValues({ minimum: "", maximum: "", value: "" });
      } else {
        show_toast("Please fill all slab fields", "error");
      }
    } else {
      setRates((prev) => [...prev, { type: rateType, value: values.rateValue || "" }]);
    }
  };

  const handleSubmit = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      setProductBenefit((prev) => ({ ...prev, loading: true }));
      try {
        console.log("Submitting payload:", values);
        const payload = {
          benefitCategory: values.benefitCategory,
          benefitName: values.benefitName,
          benefitReference: values.benefitReference,
          benefitDescription: values.benefitDescription,
      
          benefitEmbededProductRef: values.benefitEmbededProductRef,
         
          benefitCoverType: values.benefitCoverType,
          isPremiumBenefit: values.isPremiumBenefit,
          benefitrateBaseOn: values.benefitrateBaseOn,
          benefitRateSystemref: values.benefitRateSystemref,
          isConsumedonClaim: values.isConsumedonClaim,
          claimReinstatement: values.claimReinstatement,
          rates,
        };
        const response = await (await api_srv).create_product_benefit(payload);
        console.log("API response:", response);
        fetchProductBenefits();
        modalClose();
        onHide?.()
        show_toast(`Product Benefit ${values.benefitName} added successfully`, "success");
        // 'dashboard/setup/products'
        resetForm();
        setRates([]);
      } catch (err) {
        console.error("Error adding product benefit:", err.message, err.stack);
        show_toast(`Failed to add product benefit: ${err.message}`, "error");
      } finally {
        setProductBenefit((prev) => ({ ...prev, loading: false }));
        setSubmitting(false);
      }
    },
    [fetchProductBenefits, modalClose, setProductBenefit, rates]
  );

  // useEffect(() => {
  //   fetchBenefits();
  // }, [fetchBenefits]);

  const fieldOptions = {
    benefitCoverType: [
      { value: "comprehensive", label: "Comprehensive" },
      { value: "basic", label: "Basic" },
      { value: "standard", label: "Standard" },
    ],
    isPremiumBenefit: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    benefitrateBaseOn: [
      { value: "PREMIUM", label: "Premium" },
      { value: "PRODUCT", label: "Product" },
      { value: "FIXED", label: "Fixed" },
    ],
    isConsumedonClaim: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    claimReinstatement: [
      { value: "ENDORSMENT", label: "Endorsement" },
      { value: "AUTO", label: "Auto" },
      { value: "NOT_AVAILABLE", label: "Not Available" },
    ],
    rateType: [
      { value: "fixed", label: "Fixed" },
      { value: "slab", label: "Slab" },
      { value: "percentage", label: "Percentage" },
    ],
    benefitType: [
      { value: "HEALTH", label: "Health" },
      { value: "LIFE", label: "Life" },
      { value: "OTHER", label: "Other" },
    ],
    benefitServiceType: [
      { value: "INPATIENT", label: "Inpatient" },
      { value: "OUTPATIENT", label: "Outpatient" },
      { value: "BOTH", label: "Both" },
    ],
  };

  const renderRadioGroup = (name, label, options, values) => (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
        {options && options?.map((option) => (
          <div key={option.value} className="form-check">
            <Field
              type="radio"
              name={name}
              value={option.value}
              className="form-check-input"
              id={`${name}-${option.value}`}
              onChange={(e) => {
                console.log(`${label} changed to:`, e.target.value);
                const { handleChange } = values;
                handleChange(e);
              }}
            />
            <label className="form-check-label" htmlFor={`${name}-${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
      <ErrorMessage name={name} component="div" className="text-danger small mt-1" />
    </div>
  );

  const renderRadioGroupGrid = (name, label, options, values) => {
    const columns = 2;
    const itemsPerColumn = Math.ceil(options.length / columns);
    const splitOptions = Array.from({ length: columns }, (_, colIndex) =>
      options.slice(colIndex * itemsPerColumn, (colIndex + 1) * itemsPerColumn)
    );

    return (
      <div className="mb-2">
        <label className="form-label form-label-sm">{label}</label>
        <div className="row g-2">
          {splitOptions.map((columnOptions, colIndex) => (
            <div key={colIndex} className="col">
              {columnOptions.map((option) => (
                <React.Fragment key={option.value}>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name={name}
                      value={option.value}
                      className="form-check-input"
                      id={`${name}-${option.value}`}
                    />
                    <label className="form-check-label" htmlFor={`${name}-${option.value}`}>
                      {option.label}
                    </label>
                  </div>
                  {values.calculationType === option.value && (
                    <div className="mt-2 mb-2 ms-4">
                      <Field
                        name="value"
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Enter value"
                      />
                      <ErrorMessage name="value" component="div" className="text-danger small mt-1" />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
        <ErrorMessage name={name} component="div" className="text-danger small mt-1" />
      </div>
    );
  };

  const renderCheckbox = (name, label) => (
    <div className="mb-2">
      <div className="form-check">
        <Field
          type="checkbox"
          name={name}
          value="yes"
          className="form-check-input"
          id={name}
        />
        <label className="form-check-label" htmlFor={name}>
          {label}
        </label>
      </div>
      <ErrorMessage name={name} component="div" className="text-danger small mt-1" />
    </div>
  );

  return (
    <div className="container-fluid py-4">
      <div className="card #shadow p-4">
        <Formik
          initialValues={{
            benefitCategory: productBenefit?.benefitCategory || "",
            benefitName: productBenefit?.benefitName || "",
            benefitReference: productBenefit?.benefitReference || "",
            benefitDescription: productBenefit?.benefitDescription || "",
      
            benefitEmbededProductRef: productBenefit?.benefitEmbededProductRef || "",
   
            benefitCoverType: productBenefit?.benefitCoverType || "comprehensive",
            isPremiumBenefit: productBenefit?.isPremiumBenefit || true,
            benefitrateBaseOn: productBenefit?.benefitrateBaseOn || "PREMIUM",
            benefitRateSystemref: productBenefit?.benefitRateSystemref || "",
            isConsumedonClaim: productBenefit?.isConsumedonClaim || true,
            claimReinstatement: productBenefit?.claimReinstatement || "ENDORSMENT",
            rateType: productBenefit?.rateType || "fixed",
            rateValue: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            console.log("Form submission triggered with values:", values);
            handleSubmit(values, actions);
          }}
          enableReinitialize
        >
          {({ isSubmitting, values, handleChange }) => (
            <Form className="needs-validation" noValidate>
              <FormDebug />
              <div className="mb-4 pb-4 border-bottom">
                <h4 className="mb-3">General Information</h4>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label htmlFor="benefitCategory" className="form-label">Category</label>
                    <Field
                      as="select"
                      name="benefitCategory"
                      className="form-control form-control-sm"
                      onChange={(e) => {
                        console.log("Benefit Category changed to:", e.target.value);
                        handleChange(e);
                      }}
                    >
                      <option value="">Select a category</option>
                      {benefits && benefits?.map((benefit) => (
                        <option key={benefit.id} value={benefit.name}>
                          {benefit.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="benefitCategory" component="div" className="text-danger small mt-1" />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="benefitReference" className="form-label">Internal Reference</label>
                    <Field
                      name="benefitReference"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter benefit reference"
                      onChange={(e) => {
                        console.log("Benefit Reference changed to:", e.target.value);
                        handleChange(e);
                      }}
                    />
                    <ErrorMessage name="benefitReference" component="div" className="text-danger small mt-1" />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="benefitName" className="form-label">Name</label>
                    <Field
                      name="benefitName"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter benefit name"
                      onChange={(e) => {
                        console.log("Benefit Name changed to:", e.target.value);
                        handleChange(e);
                      }}
                    />
                    <ErrorMessage name="benefitName" component="div" className="text-danger small mt-1" />
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="benefitDescription" className="form-label">Description</label>
                    <Field
                      as="textarea"
                      name="benefitDescription"
                      className="form-control form-control-sm"
                      placeholder="Enter benefit description"
                      onChange={(e) => {
                        console.log("Benefit Description changed to:", e.target.value);
                        handleChange(e);
                      }}
                    />
                    <ErrorMessage name="benefitDescription" component="div" className="text-danger small mt-1" />
                  </div>
                </div>
              </div>

              <div className="mb-4 pb-4 border-bottom">
                <h4 className="mb-3">Benefit Details</h4>
                <div className="row g-3">
                  <div className="col-md-4">
                    {renderRadioGroup("benefitCoverType", "Cover Type", fieldOptions.benefitCoverType, { ...values, handleChange })}
                  </div>
                  <div className="col-md-4">
                    {renderRadioGroup("isPremiumBenefit", "Is Premium Benefit", fieldOptions.isPremiumBenefit, { ...values, handleChange })}
                  </div>
                  <div className="col-md-4">
                    {renderRadioGroup("isConsumedonClaim", "Consumed on Claim", fieldOptions.isConsumedonClaim, { ...values, handleChange })}
                  </div>
                  <div className="col-md-4">
                    {renderRadioGroup("claimReinstatement", "Claim Reinstatement", fieldOptions.claimReinstatement, { ...values, handleChange })}
                  </div>
                  <div className="col-md-4">
                    {renderRadioGroup("benefitrateBaseOn", "Rate Base", fieldOptions.benefitrateBaseOn, { ...values, handleChange })}
                  </div>
                  {values.benefitrateBaseOn === "PRODUCT" && (
                    <div className="col-md-4">
                      <label htmlFor="benefitEmbededProductRef" className="form-label">Embedded Product Reference</label>
                      <Field
                        as="select"
                        name="benefitEmbededProductRef"
                        className="form-control form-control-sm"
                        onChange={(e) => {
                          console.log("Embedded Product Reference changed to:", e.target.value);
                          handleChange(e);
                        }}
                      >
                        <option value="">Select a reference product</option>
                        {benefits?.((benefit) => (
                          <option key={benefit.id} value={benefit.name}>
                            {benefit.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="benefitEmbededProductRef" component="div" className="text-danger small mt-1" />
                    </div>
                  )}
                </div>
              </div>

              <div>
                <h4 className="mb-3">Rate Information</h4>
                {renderRadioGroup("rateType", "Rate Type", fieldOptions.rateType, { ...values, handleChange })}

                {values.rateType !== "slab" ? (
                  <div className="mb-3">
                    <label htmlFor="rateValue" className="form-label">Rate Value</label>
                    <div className="input-group input-group-sm">
                      <Field
                        name="rateValue"
                        type="text"
                        className="form-control"
                        placeholder="Enter rate value"
                        onChange={(e) => {
                          console.log("Rate Value changed to:", e.target.value);
                          handleChange(e);
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => addRate(values.rateType, values)}
                      >
                        Add Rate
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="mb-3">
                    <h6 className="mb-2">Slab Details</h6>
                    <div className="row g-3 align-items-end">
                      <div className="col-sm-6 col-md-3">
                        <label htmlFor="minimum" className="form-label">Minimum</label>
                        <input
                          name="minimum"
                          type="text"
                          value={slabValues.minimum}
                          onChange={handleSlabChange}
                          className="form-control form-control-sm"
                          placeholder="Enter minimum"
                        />
                      </div>
                      <div className="col-sm-6 col-md-3">
                        <label htmlFor="maximum" className="form-label">Maximum</label>
                        <input
                          name="maximum"
                          type="text"
                          value={slabValues.maximum}
                          onChange={handleSlabChange}
                          className="form-control form-control-sm"
                          placeholder="Enter maximum"
                        />
                      </div>
                      <div className="col-sm-6 col-md-3">
                        <label htmlFor="value" className="form-label">Value</label>
                        <input
                          name="value"
                          type="text"
                          value={slabValues.value}
                          onChange={handleSlabChange}
                          className="form-control form-control-sm"
                          placeholder="Enter value"
                        />
                      </div>
                      <div className="col-sm-6 col-md-3">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm w-100"
                          onClick={() => addRate(values.rateType, values)}
                        >
                          Add Rate
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {rates.length > 0 && (
                  <div className="mt-4 pt-4 border-top">
                    <h5 className="mb-2">Added Rates</h5>
                    <ul className="list-group list-group-flush">
                      {rates && rates?.map((rate, index) => (
                        <li key={index} className="list-group-item">
                          {rate.type === "slab"
                            ? `Slab: Minimum ${rate.minimum}, Maximum ${rate.maximum}, Value ${rate.value}`
                            : `${rate.type.charAt(0).toUpperCase() + rate.type.slice(1)}: ${rate.value}`}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <div className="d-flex justify-content-start gap-3 mt-4">
                <button
                  type="submit"
                  disabled={isSubmitting || productBenefit?.loading}
                  className="btn btn-primary btn-lg d-fle x align-items-center"
                >
                  {productBenefit?.loading || isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Saving...
                    </>
                  ) : (
                    "Save Benefit"
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-lg"
                  onClick={modalClose}
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
